var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_716",
    "data-name": "Group 716",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_372",
    "data-name": "Rectangle 372",
    width: 30,
    height: 30,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_715",
    "data-name": "Group 715",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12768",
    "data-name": "Path 12768",
    d: "M30,15A15,15,0,1,1,15,0,15,15,0,0,1,30,15",
    fill: "#7c97c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12769",
    "data-name": "Path 12769",
    d: "M22.219,23H7.78A2.575,2.575,0,0,1,5.208,20.43V9.571A2.575,2.575,0,0,1,7.78,7H22.219a2.575,2.575,0,0,1,2.572,2.572V20.43A2.575,2.575,0,0,1,22.219,23M7.78,8.541a1.031,1.031,0,0,0-1.03,1.03V20.43a1.031,1.031,0,0,0,1.03,1.029H22.219a1.031,1.031,0,0,0,1.03-1.029V9.571a1.031,1.031,0,0,0-1.03-1.03Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12770",
    "data-name": "Path 12770",
    d: "M15,15.994l-7.344-4.65a.771.771,0,1,1,.825-1.3L15,14.169l6.519-4.128a.771.771,0,1,1,.825,1.3Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.a41f1ab697a990c31f545e0f96f84122.svg";
export { ForwardRef as ReactComponent };